import { inject, Injectable } from '@angular/core';
import { SqliteService } from '@app/services';
import { StoreModel } from '@app/models';
import { environment } from '@env/environment';

@Injectable({
    providedIn: 'root',
})
export class PowerOfOneRepository
{
    private readonly keys = {
        tableName: 'power_of_one_stores',
    };
    private sqliteService = inject(SqliteService);

    async savePowerOfOneStores(externalIds: string[]): Promise<void>
    {
        if (!environment.powerOfOneEnabled)
        {
            return;
        }

        const columns = [
            'store_external_id',
        ];
        const batchSize = Math.floor(3000 / columns.length);

        for (let i = 0; i < externalIds.length; i += batchSize)
        {
            const chunk = externalIds.slice(i, i + batchSize);
            const valuePlaceholders = this.sqliteService.getValuePlaceholder(chunk.length, columns.length);
            const sql = `
                INSERT INTO ${this.keys.tableName} (${columns.join(', ')})
                VALUES ${valuePlaceholders};
            `;
            const values: any[] = chunk.flatMap((p) => [
                p,
            ]);
            await this.sqliteService.save(sql, values);
        }
    }

    async isPowerOfOne(store: StoreModel): Promise<boolean>
    {
        if (!environment.powerOfOneEnabled)
        {
            return false;
        }

        const sql = `
            SELECT EXISTS(SELECT 1
                          FROM ${this.keys.tableName}
                          WHERE store_external_id = ?) AS result;
        `;
        const data = await this.sqliteService.get(sql, [store.external_id]) ?? [];

        return data[0].result > 0;
    }
}
